import React, { useContext, useState, useEffect, FunctionComponent, useMemo } from "react";
import { useTranslation } from "react-i18next";

// d.ts
import { IDataController, DCRecord } from "@/@types/lib/dataController"

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import DialogContext from "@/ui/DialogContext/DialogContext";

import modelKatovi from "@/models/katovi"
import dataController from "@/lib/dataController";
import LoaderContext from "@/components/LoaderContext/LoaderContext";
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";

//Types
import { LoaderContextType } from "@/@types/context/LoaderContext";
import { SnackbarContextType } from "@/@types/ui/SnackbarContext";
import { DialogContextType } from "@/@types/ui/DialogContext";

// TODO:
// subModels cleanup: they are added to the project because Table.jsx can not function without them

interface IQualityControlKatoviTableProps {
  isQcChecked: boolean;
  baseRecordPath: string;
  baseRecordId: number | null;
  selectedKat: DCRecord | null;
  onRowSelect: (id: number, record: DCRecord | null) => any;
}

const QualityControlKatoviTable: FunctionComponent<React.PropsWithChildren<IQualityControlKatoviTableProps>> = (props) => {
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext) as LoaderContextType;
  const snackbarContext = useContext(SnackbarContext) as SnackbarContextType;
  const [defaultSelectedRow, setDefaultSelectedRow] = useState<number>(-1);

  const [records, setRecords] = useState<DCRecord[]>([]);
  const [revisionCounter, setRevisionCounter] = useState(0);

  const { t } = useTranslation();

  const { baseRecordPath, baseRecordId, selectedKat, onRowSelect, isQcChecked } = props;

  const endsWithSlash = baseRecordPath.lastIndexOf('/') === baseRecordPath.length - 1 ? true : false;
  const url = `${baseRecordPath}${endsWithSlash ? "" : "/"}${baseRecordId}/katovi`;

  const dc: IDataController = new dataController(modelKatovi, url);

  useEffect(() => {
    if (baseRecordId !== null) {
      refreshRecords();
    } else {
      setRecords([]);
    }
  }, [baseRecordId])

  useEffect(() => {
    refreshRecords();
  }, [revisionCounter])

  const refreshRecords = () => {
    // loaderContext.toggleLoading(true);
    if (baseRecordId === null) return;
    dc.GetData()
      .then((resp) => {
        if (resp.success && Array.isArray(resp.data)) {
          setRecords(resp.data);
          if (resp.data.length === 0) {
            snackbarContext.showNotification("messages.nodata_katovi", "warning");
          }
        };
      })
      .catch((resp) => {
        console.log(resp);
      })
      .finally(() => {
        // loaderContext.toggleLoading(false);
      });
  };
  
  const handleRowSelect = (id: number) => {
    const selectedRecord = records.find(kat => kat.id === id);
    onRowSelect(id, selectedRecord || null);
    return true;
  }

  const selectedId = useMemo(() => {
    if (selectedKat) {
      return selectedKat.id 
    } else return -1;
  }, [selectedKat])
 
  useEffect(() => {
    if (records && records !== null && Array.isArray(records) && records.length > 0) {
      const defaultRow = records.find((x) => x.broj_kata === 0)
      if (defaultRow && defaultRow !== null && defaultRow.id) {
        setDefaultSelectedRow(Number(defaultRow?.id));
        handleRowSelect(Number(defaultRow?.id));
      }
    }
  }, [records]);

  return (
    <ModelTable
      title={t("titles.katovi")}
      records={records}
      viewName="default"
      dc={dc}
      allowSearchBar={false}
      allowSelection="one"
      allowFilter={false}
      allowExport={false}
      allowColumnPicker={false}
      allowEdit={false}
      allowInlineEdit={false}
      allowInlineEditQuickly={false}
      allowDelete={false}
      useDeleteButton={false}
      allowInc={false}
      disableControls={true}
      disableInlineControls={true}
      preventEventDefault={false}
      showControlSwitch={false}
      onRowAction={(id: any) => { console.log(id) }}
      onRowClick={handleRowSelect}
      rowSelectedCustom={selectedId !== -1 ? selectedId as number : defaultSelectedRow}
      initialPageSize={25}
      allowRowAction={() => { return false; }}
      trackTableState={false}
      unselectRow={false}
      customRecordCount={records.length}
      gotoFirstPageOnSelect={true}
    />
  );
}

export default QualityControlKatoviTable;
